// extracted by mini-css-extract-plugin
module.exports = {"categoryView":"CategoryView_categoryView__3seya","name":"CategoryView_name__2BQS1","selected":"CategoryView_selected__3Zkkr"};